module.exports = __webpack_public_path__ + "img/icone-beans.afcb9c02.svg";